import script from "./invalid.vue?vue&type=script&lang=ts&setup=true"
export * from "./invalid.vue?vue&type=script&lang=ts&setup=true"

import "./invalid.vue?vue&type=style&index=0&id=54fd7c4e&lang=scss"

const __exports__ = script;

export default __exports__